import { render, staticRenderFns } from "./DetailOptions.vue?vue&type=template&id=2e365dda&scoped=true&"
import script from "./DetailOptions.vue?vue&type=script&lang=js&"
export * from "./DetailOptions.vue?vue&type=script&lang=js&"
import style0 from "./DetailOptions.vue?vue&type=style&index=0&id=2e365dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e365dda",
  null
  
)

export default component.exports